import { render, staticRenderFns } from "./AssetParquetStatusParameter.vue?vue&type=template&id=09f10388&"
import script from "./AssetParquetStatusParameter.vue?vue&type=script&lang=ts&"
export * from "./AssetParquetStatusParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports